import 'vuetify/styles';

import { h } from 'vue';
import { Icon } from '@iconify/vue';
import { createVuetify } from 'vuetify';
// eslint-disable-next-line sonarjs/no-wildcard-import
import * as labs from 'vuetify/labs/components';
import type { IconSet } from 'vuetify';

// colors currently are not configured for ts import
// import colors from 'vuetify/lib/util/colors'
declare const __CI__: boolean;

const iconifySet: IconSet = {
  component: (props) => h(Icon, { icon: props.icon as string }),
};

console.log(__CI__);
export default createVuetify({
  defaults: {
    VTextField: {
      variant: 'outlined',
    },
    VTextarea: {
      variant: 'outlined',
    },
    VAutocomplete: {
      variant: 'outlined',
    },
    VSelect: {
      variant: 'outlined',
    },
    VNumberInput: {
      variant: 'outlined',
    },
    VMenu: __CI__ ? { transition: false, openDelay: 0, closeDelay: 0 } : {},
  },
  components: {
    ...labs,
  },

  icons: {
    defaultSet: 'iconify',
    sets: { iconify: iconifySet },
    aliases: {
      collapse: 'ph:caret-up-duotone',
      complete: 'ph:check-duotone',
      cancel: 'ph:x-circle-duotone',
      close: 'ph:x',
      delete: 'ph:x-circle-duotone',
      clear: 'ph:x',
      success: 'ph:check-circle-duotone',
      info: 'ph:info-duotone',
      warning: 'ph:warning-duotone',
      error: 'ph:x-circle-duotone',
      prev: 'ph:caret-left-duotone',
      next: 'ph:caret-right-duotone',
      checkboxOn: 'ph:check-square-fill',
      checkboxOff: 'ph:square-duotone',
      checkboxIndeterminate: 'ph:minus-square-duotone',
      delimiter: 'ph:circle-fill',
      sortAsc: 'ph:arrow-up-duotone',
      sortDesc: 'ph:arrow-down-duotone',
      expand: 'ph:caret-down-duotone',
      menu: 'ph:list',
      subgroup: 'ph:caret-down-duotone',
      dropdown: 'ph:caret-down-duotone',
      radioOn: 'ph:radio-button-duotone',
      radioOff: 'ph:circle-duotone',
      edit: 'ph:pencil-simple-duotone',
      ratingEmpty: 'ph:star-duotone',
      ratingFull: 'ph:star-fill',
      ratingHalf: 'ph:star-half-fill',
      loading: 'ph:spinner-duotone',
      first: 'ph:skip-back-duotone',
      last: 'ph:skip-forward-duotone',
      unfold: 'ph:arrows-out-line-vertical-duotone',
      file: 'ph:file-duotone',
      plus: 'ph:plus',
      minus: 'ph:minus-duotone',
      calendar: 'ph:calendar-duotone',
    },
  },

  theme: {
    variations: {
      colors: ['primary', 'error', 'warning'],
      lighten: 5,
      darken: 5,
    },
    themes: {
      dark: {
        colors: {
          primary: '#1976D2', //blue-darken-2
          error: '#D32F2F', //red-darken-2
          success: '#388E3C', //green-darken-2
          warning: '#F57C00', // orange-darken-2
          'project-inhouse': '#1976D2', // blue-darken-2
          'project-outsource': '#F9A825', // yellow-darken-3
          'project-internal': '#AD1457', // pink-darken-3
        },
      },
      light: {
        colors: {
          primary: '#42A5F5', //blue-lighten-1
          'project-inhouse': '#1976D2',
          'project-outsource': '#F9A825',
          'project-internal': '#AD1457',
        },
      },
    },
  },
});
